// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1vAD3","row":"styles_row__3n-Cg"};